import { inject } from '@angular/core';
import { type Route } from '@angular/router';
import { populationsLayoutConfig } from '@bizzdesign/feature-layout';
import { baseRoutes } from '@bizzdesign/shared/utils';
import { FeatureFlagsStore } from '@bizzdesign/shared/feature-flags';

export const POPULATIONS_OVERVIEW_ROUTE = 'populations';

export const FEATURE_POPULATIONS_ROUTES: Route[] = [
  {
    path: baseRoutes.populations,
    pathMatch: 'full',
    loadComponent: () =>
      import(
        './containers/populations-container/populations-container.component'
      ).then((mod) => mod.PopulationsContainerComponent),
    data: {
      layoutConfig: populationsLayoutConfig,
      path: POPULATIONS_OVERVIEW_ROUTE,
    },
    canMatch: [() => inject(FeatureFlagsStore).populationsEnabled()],
  },
];
